export const API_PATH = {
    login: '/login',
    Glogin: '/google-login',
    GoLogin: '/organization-google-login',
    oLogin: '/organization-login',
    location: '/location',
    timeGroup: '/time-group',
    kpi: '/kpi',
    Hmi: '/hmi',
    deviceList: '/deviceList',
    installationList: '/installationList',
    installationDeviceList: '/installationDeviceList',
    totalNotifications: '/totalNotifications',
    getNotifications: '/getNotifications',
    markAllRead: '/markAllRead',
    diagramAxis: '/diagramAxis',
    diagram: '/diagram',
    locationAxis: '/locationAxis',
    getLocation: "/getLocation",
    notificationChannel: "/notificationChannel",
    pushNotification: "/pushNotification",
    controller: "/controller",
    graphHeader: "/graph-header",
    graphData: "/graph-data",
    alertNotifications: "/get-alert-notification",
    icondevice: "/icon-device",
    widget: "/widget",
    forget: "/forget-Password",
    verify: "/verify",
    set: "/set"
}